import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Lock + privacy reassurance under a photo question. See client/components/quiz/CLAUDE.md. */
@Component({
  selector: 'app-quiz-secure-photo-note',
  templateUrl: './quiz-secure-photo-note.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizSecurePhotoNoteComponent {}
